import m, {MithrilComponent} from '@bitstillery/mithril'
import {rich_text} from '@bitstillery/common/cms/lib/inline_markup'

import type {CmsComponentMeta} from '@bitstillery/common/cms/catalog_meta'

export const headingMeta = {
    tier: 'content',
    summary: 'Section or page heading — the `level` owns both the tag and the styling.',
    when_to_use: 'Use for every heading. `Section` and `HeroBand` titles already render a `Heading` internally.',
    example: `
    <Heading level={2}>Popular categories</Heading>
    `,
} satisfies CmsComponentMeta

export interface HeadingAttrs {
    /** Semantic heading level 1–6 (default `2`) — drives both the rendered tag (`h1`–`h6`) and the styling. */
    level?: 1 | 2 | 3 | 4 | 5 | 6
}

/** Accepts `level={2}` or `level="2"` (assistant output); clamps to 1–6. */
function heading_level(value: unknown): number {
    const n = Math.trunc(Number(value))
    if (!Number.isFinite(n) || n < 1) {
        return 2
    }
    return n > 6 ? 6 : n
}

/**
 * Section/page heading. The level owns the look — authors cannot restyle it, so headings stay
 * consistent everywhere. Text goes as children.
 */
export class Heading extends MithrilComponent<HeadingAttrs> {
    view(vnode: m.Vnode<HeadingAttrs>) {
        const level = heading_level(vnode.attrs.level ?? 2)
        return m(`h${level}`, {className: `cms-heading cms-heading-${level}`}, rich_text(vnode.children))
    }
}
